module.exports = __webpack_public_path__ + "static/media/step4.d1447011.png";